<ng-container [ngSwitch]="icon">
  <svg
    *ngSwitchCase="iconEnum.ArrowRight"
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.375 13.5H22.125M22.125 13.5L14.25 5.625M22.125 13.5L14.25 21.375"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Walking"
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.3727 3.95915C17.3147 4.59264 16.7706 5.04015 16.1576 4.99713C15.5734 4.95613 15.0886 4.41909 15.1272 3.79016C15.1852 3.15982 15.7246 2.71381 16.3341 2.75233C16.9649 2.81008 17.4112 3.34965 17.3727 3.95915Z"
      stroke="black"
      stroke-width="2.25" />
    <path
      d="M12.375 16.25L16.3125 19.25L18 25.25"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round" />
    <path
      d="M14.625 7.25L12.6964 15.4786L10.125 20.1071L5.625 25.25"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round" />
    <path
      d="M14.625 7.25L9 11.6971L7.875 15.125"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round" />
    <path
      d="M14.625 7.25L16.5886 11.7005L21.375 14"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Plus"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.625 13.5H21.375M13.5 5.625V21.375"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Map"
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.125 3.875L3.375 7.25V24.125L10.125 20.75M10.125 3.875L16.875 7.25M10.125 3.875V20.75M16.875 7.25L23.625 3.875V20.75L16.875 24.125M16.875 7.25V24.125M16.875 24.125L10.125 20.75"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Close"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.25 6.75L6.75 20.25M6.75 6.75L20.25 20.25"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.ExternalLink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Mail"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 7L13.03 12.7C12.7213 12.8934 12.3643 12.996 12 12.996C11.6357 12.996 11.2787 12.8934 10.97 12.7L2 7M4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.Phone"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4741 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4018C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.945 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3146 6.72527 15.2661 5.18993 12.85C3.49991 10.2412 2.44818 7.27097 2.11993 4.17997C2.09494 3.90344 2.12781 3.62474 2.21643 3.3616C2.30506 3.09846 2.4475 2.85666 2.6347 2.6516C2.82189 2.44653 3.04974 2.28268 3.30372 2.1705C3.55771 2.05831 3.83227 2.00024 4.10993 1.99997H7.10993C7.59524 1.9952 8.06572 2.16705 8.43369 2.48351C8.80166 2.79996 9.04201 3.23942 9.10993 3.71997C9.23656 4.68004 9.47138 5.6227 9.80993 6.52997C9.94448 6.8879 9.9736 7.27689 9.89384 7.65086C9.81408 8.02482 9.6288 8.36809 9.35993 8.63998L8.08993 9.90997C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0554 17.4699 14.19C18.3772 14.5285 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
  <svg
    *ngSwitchCase="iconEnum.List"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.5 7.25H24.125M9.5 14H24.125M9.5 20.75H24.125M3.875 7.25H3.88625M3.875 14H3.88625M3.875 20.75H3.88625"
      stroke="black"
      stroke-width="2.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</ng-container>
